import { render, staticRenderFns } from "./ProductService.vue?vue&type=template&id=a80683d0"
import script from "./ProductService.vue?vue&type=script&lang=js"
export * from "./ProductService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports